import { render, staticRenderFns } from "./agGridBrief.vue?vue&type=template&id=3b7299de&scoped=true&"
import script from "./agGridBrief.vue?vue&type=script&lang=js&"
export * from "./agGridBrief.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7299de",
  null
  
)

export default component.exports